//
//
//
//
//
//
//
//
//
//
//
//
//

import BlogArticle from '~/modules/storyblok/components/page-types/BlogArticle.vue';
import BlogFile from '~/modules/storyblok/components/page-types/BlogFile.vue';
import BlogCategory from '~/modules/storyblok/components/page-types/BlogCategory.vue';
import BlogCategoryFile from '~/modules/storyblok/components/page-types/BlogCategoryFile.vue';
import Breadcrumbs from '~/modules/storyblok/components/Blog/BlogBreadcrumbs.vue';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BlogPage',
  components: {
    BlogFile,
    BlogArticle,
    BlogCategory,
    Breadcrumbs,
    BlogCategoryFile,
  },
  layout: 'basic',
  middleware: [
    'story-url-resolver',
  ],
  // eslint-disable-next-line @typescript-eslint/require-await
  async asyncData(context) {
    const localeSbUrl = context.$localeSbUrl;
    const { error: nuxtError } = context;
    if (context.app.currentStory) {
      const storyType = () => {
        const type = context.app.currentStory?.content?.component;
        switch (type) {
          case 'blogArticle':
            return 'blogArticle';
          // case 'blogFile':
          //   return 'blogFile';
          case 'blogCategory':
            return 'blogCategory';
          // case 'blogSubCategory':
          //   return 'blogCategory';
          // case 'blogSubCategory_files':
          //   return 'blogCategoryFile';
          default:
            nuxtError({ statusCode: 404 });
            return null;
        }
      };
      return { currentStory: context.app.currentStory, storyType: storyType(), localeSbUrl };
    }
    return { currentStory: null, storyType: null, localeSbUrl };
  },
  head: {},
  watch: {
    '$i18n.locale': {
      handler(newLocale, oldLocale) {
        try {
          if (!oldLocale || !this.currentStory || !this.localePath || !this.$router) return;
          const localeSbUrl = this.$localeSbUrl || this.localeSbUrl;
          const slug = localeSbUrl({ slug: this.currentStory.default_full_slug });
          this.$nextTick(() => {
            this.$router.push(slug);
          });
        } catch (error) {
          console.error('Navigation failed:', error);
        }
      },
      immediate: true,
    },
  },
});
